'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const index = require('./index-8d6fcb04.js');

const rgMaskLinkCss = ":host{display:block}.reveal-link{all:unset;margin-left:1em;margin-right:0.5em;text-decoration:underline;font-weight:500;font-size:inherit;cursor:pointer}.reveal-link:hover,.reveal-link:focus{text-decoration:underline;color:#333}.reveal-link::-moz-focus-inner{border-style:none;padding:0}.reveal-link:-moz-focusring{outline:none}";

const RgMaskLink = class {
    constructor(hostRef) {
        index.registerInstance(this, hostRef);
        this.rgReveal = index.createEvent(this, "rg-reveal", 7);
        // 1. Own properties
        // ---------------------------------------
        this.maskedHref = "";
        this.maskedInnerText = "";
        this.maskedTitle = "";
        /**  */
        this.iconRatio = 1.1;
        /** todo */
        this.iconShow = true;
        /** todo */
        this.hidden = true;
    }
    hiddenChanged() {
        const { hidden } = this;
        if (!hidden)
            this.handleUnmask();
    }
    // 6. Component lifecycle events
    // ---------------------------------------
    connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        let slottedLink = this.element.querySelector("a");
        if (!!slottedLink) {
            this.maskedHref = slottedLink.href;
            this.maskedInnerText = slottedLink.innerText;
            this.maskedTitle = slottedLink.title;
            slottedLink.title = "Click to reveal";
            slottedLink.removeAttribute("href");
            let textKeep = "";
            if (this.type === "mobile") {
                textKeep = slottedLink.innerText.slice(-3);
            }
            if (this.type === "email") {
                textKeep = slottedLink.innerText.match(/@.*/)[0];
            }
            if (this.type === "website") {
                textKeep = slottedLink.innerText.match(/\.\w*$/)[0];
            }
            let textMask = slottedLink.innerText;
            if (textKeep.length > 0) {
                textMask = textMask.slice(0, textKeep.length * -1);
            }
            textMask = textMask.replace(/[^ ]/g, "•");
            slottedLink.innerText = textMask + textKeep;
        }
    }
    // 7. Listeners
    // ---------------------------------------
    // 8. Public methods API
    // ---------------------------------------
    /** todo */
    async reveal() {
        if (this.hidden)
            this.hidden = false;
    }
    // 9. Local methods
    // ---------------------------------------
    handleUnmask() {
        // console.log("handleUnmask");
        let slottedLink = this.element.querySelector("a");
        if (!!slottedLink) {
            // console.log(slottedLink.href, this.maskedHref);
            slottedLink.title = this.maskedTitle;
            slottedLink.href = this.maskedHref;
            slottedLink.innerText = this.maskedInnerText;
            this.rgReveal.emit();
        }
    }
    handleClick() {
        // console.log("click");
        if (this.hidden)
            this.hidden = false;
        // console.log("this.hidden", this.hidden);
    }
    getIcon() {
        if (this.icon)
            return this.icon;
        let icon = null;
        switch (this.type) {
            case "mobile":
                icon = "fas fa-phone";
                break;
            case "email":
                icon = "fas fa-paper-plane";
                break;
            case "website":
                icon = "fas fa-globe";
                break;
        }
        return icon;
    }
    // 10. render() function
    // ---------------------------------------
    render() {
        return (index.h(index.Host, null, this.iconShow && this.getIcon() && (index.h("rg-icon", { icon: this.getIcon(), margin: "right", ratio: this.iconRatio })), index.h("slot", null), this.hidden && (index.h("button", { class: "reveal-link", onClick: this.handleClick }, "Show ", this.type))));
    }
    get element() { return index.getElement(this); }
    static get watchers() { return {
        "hidden": ["hiddenChanged"]
    }; }
};
RgMaskLink.style = rgMaskLinkCss;

exports.rg_mask_link = RgMaskLink;
